import { useContext, useEffect } from 'react';
import { getEnrollmentStatus, getTreatment, logExposure, treatmentContext } from './utils';
import { TACQ0005, TACQ0006, TACQ0004 } from './Ids';
import { jsx as _jsx } from "react/jsx-runtime";
export const useLogExposure = experiment => {
  useEffect(() => {
    logExposure(experiment);
  }, [experiment]);
};
export const ExposureLogger = ({
  experiment
}) => {
  useLogExposure(experiment);
  return null;
};
export const useTreatments = () => useContext(treatmentContext);
export const useTreatment = (experiment, parameter, logTreatment = false) => {
  const resolved = useTreatments();
  const resolvedParameter = getTreatment(resolved, experiment, parameter);
  useEffect(() => {
    if (logTreatment) {
      logExposure(experiment);
    }
  }, [experiment, logTreatment]);
  return resolvedParameter;
};
export const useGetTACQ0005Treatment = () => useTreatment(TACQ0005, 'group', true);
export const useGetTACQ0004Treatment = () => useTreatment(TACQ0004, 'group');
export const useIsTACQ0004Variant = () => {
  const treatment = useGetTACQ0004Treatment();
  return treatment === 'variation';
};
export const useIsTACQ0005Variant = () => useGetTACQ0005Treatment() === 'variation';
export const useGetTACQ0006Treatment = () => useTreatment(TACQ0006, 'group');
export const useIsTACQ0006Variant = () => useGetTACQ0006Treatment() === 'variation';
export const useEnrollmentStatus = experiment => {
  const resolved = useTreatments();
  const resolvedEnrollment = getEnrollmentStatus(resolved, experiment);
  return resolvedEnrollment;
};
export const withTreatments = C => props => {
  const treatments = useTreatments();
  return /*#__PURE__*/_jsx(C, Object.assign({}, props, {
    treatments: treatments
  }));
};